export interface TourAudienceCriteria {
  roles?: string[];
  onboardingState?: "new" | "completed" | "any";
  locations?: string[];
  // P23C: direct milestone checks
  milestones?: {
    has?: string[];
    lacks?: string[];
  };
}

export interface TourAudienceRecord {
  id: string;
  slug: string;
  label: string;
  description: string | null;
  criteria: TourAudienceCriteria;
  isDefault: boolean;
  sortOrder: number;
  createdAt: string;
  updatedAt: string;
}

export interface TourRecord {
  id: string;
  audienceId: string;
  routePattern: string;
  title: string;
  description: string | null;
  isActive: boolean;
  generationMode: "manual" | "ai_assisted" | "ai_generated";
  sortOrder: number;
  createdBy: string | null;
  createdAt: string;
  updatedAt: string;
}

export type TourStepPlacement =
  | "auto"
  | "top"
  | "bottom"
  | "left"
  | "right"
  | "center";

// P23a: a step's pre-action runs once before the highlight is
// rendered — used to auto-open a menu or expand a section that
// hosts the actual target. Authors must pick controls that no-op
// on re-click (open/expand, not toggle), because Joyride re-fires
// `before` whenever a step is (re-)entered (incl. TOC jumps).
export type TourStepPreAction = {
  kind: "click";
  selector: string;
  settleMs: number;
};

export interface TourStepRecord {
  id: string;
  tourId: string;
  sortOrder: number;
  // P23C: "highlight" anchors to a DOM element; "chapter" is a centered modal card.
  stepType: "highlight" | "chapter";
  // P23a: exactly one of (targetId, targetSelector) is non-null for highlight steps.
  // Chapter steps have both null. The server-side CHECK constraint `tour_steps_target_xor`
  // guarantees this, so admin UI must enforce the same invariant before submit.
  targetId: string | null;
  targetSelector: string | null;
  preAction: TourStepPreAction | null;
  placement: TourStepPlacement;
  title: string | null;
  body: string;
  mediaFileId: string | null;
  mediaUrl: string | null;
  visibilityCriteria: TourAudienceCriteria;
  skipBeacon: boolean;
  source: "manual" | "ai_generated";
  createdAt: string;
  updatedAt: string;
}

export const LOCATION_OPTIONS = [
  { code: "BO", label: "Boston" },
  { code: "SA", label: "Salem" },
  { code: "ME", label: "Methuen" },
  { code: "CA", label: "Cape Cod" },
] as const;

export const PLACEMENT_OPTIONS: TourStepPlacement[] = [
  "auto",
  "top",
  "bottom",
  "left",
  "right",
  "center",
];
